import axios from "axios";
import { setAccessToken, setUser, logout } from "../redux/ApiSlice/Auth/AuthSlice";

export const isTokenValid = (token) => {
    if (!token) return false;
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 > Date.now();
    } catch {
        return false;
    }
};

export const initAuth = () => async (dispatch) => {
    const refreshToken = localStorage.getItem("authData")
        ? JSON.parse(localStorage.getItem("authData")).refreshToken
        : null;
    try {
        const res = await axios.post(
            `${process.env.REACT_APP_MAIN_URL}api/token/refresh/`,
            { refresh: refreshToken },
            { withCredentials: true }
        );
        dispatch(setAccessToken(res.data));
        if (res.data.user) dispatch(setUser(res.data.user));
    } catch (err) {
        dispatch(logout());
        throw err;
    }
};
